var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophoneSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 6.3V6C16 3.79 14.21 2 12 2C9.78999 2 7.99999 3.79 7.99999 6V11M9.03999 14.19C9.76999 15 10.83 15.5 12 15.5C14.21 15.5 16 13.71 16 11.5V11M6.77999 16.95C8.14999 18.22 9.97999 19 12 19M12 19C16.22 19 19.65 15.57 19.65 11.35V9.65M12 19V22M4.34999 9.65V11.35C4.34999 12.41 4.55999 13.41 4.94999 14.33M20.07 2.84L3.92999 18.99M11 3V6",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneSlash);
export default __webpack_public_path__ + "static/media/microphoneSlash.fdf72efc9bda75a2f2125f7b15bcbcf4.svg";
export { ForwardRef as ReactComponent };